import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NOTIFICATIONS_COMPONENTS_I18N_KEY } from "./constants";
export default /*#__PURE__*/_defineProperty({}, NOTIFICATIONS_COMPONENTS_I18N_KEY, {
  NOTIFICATIONS_LABEL: 'Notificações',
  NOTIFICATIONS_TITLE: 'As últimas novidades em Crehana',
  NOTIFICATIONS_COURSES: 'Cursos',
  NOTIFICATIONS_COURSE_DETAIL: 'Ver detalhes',
  NOTIFICATIONS_FEATURES: 'Updates',
  NOTIFICATIONS_ERROR: 'Ocorreu um erro, tente novamente mais tarde.',
  NOTIFICATIONS_RETRY: 'Tentar novamente',
  NOTIFICATIONS_EMPTY: 'Em breve você vai descobrir todas as novidades que temos para você!'
});